import {
  countryDataSource,
  DEFAULT_COUNTRY_KEY,
  type CountryConfig,
  type CountryDataSource,
} from '@s4l/stayforlong/datasource/CountryDatasource'

export const COUNTRIES: CountryDataSource = countryDataSource

export const DEFAULT_COUNTRY: CountryConfig = COUNTRIES[DEFAULT_COUNTRY_KEY]
